import * as React from "react";
import { DesignChooser } from "./DesignChooser";
import { useShareFlow } from "./ShareFlowProvider";
import { StyleCell } from "./StyleBar";

/** The look, for a prompt opened from the library: the design comes with it, so it's a setting, not a grid. */
export const LookCell: React.FC<{ disabled: boolean }> = ({ disabled }) => {
  const flow = useShareFlow();
  const [open, setOpen] = React.useState(false);
  const design = flow.design;
  if (!design) return null;

  return (
    <StyleCell
      label="Look"
      value={design.name}
      preview={design.thumbnailUrl ? <img src={design.thumbnailUrl} alt="" className="size-full object-cover" /> : null}
      disabled={disabled}
      open={open}
      onOpenChange={setOpen}
      contentClassName="w-[min(92vw,460px)] p-3"
      data-testid="look-cell"
    >
      <div className="flex flex-col gap-2">
        <span className="text-sm font-semibold text-slate-800">Pick a look</span>
        <DesignChooser
          designs={flow.looks}
          loading={flow.designsLoading}
          selectedId={flow.designPackageId}
          onSelect={id => {
            setOpen(false);
            if (id !== flow.designPackageId) flow.selectDesign(id);
          }}
          showMultiImageHint={flow.mode === "single"}
        />
      </div>
    </StyleCell>
  );
};
